module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('main', {
    staticClass: "settings",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('nav', {
    staticClass: "settings-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/profile"
    }
  }, [_vm._v("\n                        Profile\n                    ")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/account"
    }
  }, [_vm._v("\n                        Account\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/campaigns"
    }
  }, [_vm._v("\n                        Campaigns\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/fields"
    }
  }, [_vm._v("\n                        Fields\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/tags"
    }
  }, [_vm._v("\n                        Tags\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/filters"
    }
  }, [_vm._v("\n                        Filters\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings/models"
    }
  }, [_vm._v("\n                        Models\n                    ")])], 1) : _vm._e()])]), _vm._v(" "), _vm._t("main"), _vm._v(" "), _vm._t("footer")], 2), _vm._v(" "), _vm._t("modals", null, {
    "slot": "modals"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2644c7d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/AdminLayout.vue
// module id = 631
// module chunks = 0